import { HStack } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';

import { FilterCard } from '$/pages/DashboardPages/pages/Inspiration/components/FilterCard/FilterCard';
import { LoadingFilterCard } from '$/pages/DashboardPages/pages/Inspiration/components/FilterCard/LoadingFilterCard';
import { allInspirationsQuery } from '$/services/usecases/inspirations/queries';
import { repeat } from '$/utils/arrayUtils';

export const FilterSection = () => {
  const { data, isLoading } = useQuery(allInspirationsQuery());

  const inspirations = data?.response.payload;
  const categories = [...new Set(inspirations?.map((i) => i.category))];

  return (
    <HStack>
      <HStack
        className='hidden-scrollbar'
        wrap={{ base: 'nowrap', md: 'wrap' }}
        gap={{ base: '2', md: '4' }}
        overflowX={{ base: 'auto', md: 'hidden' }}
      >
        {isLoading &&
          repeat(8).map((id) => <LoadingFilterCard key={id} id={id} />)}

        {categories.map((category) => (
          <FilterCard
            key={category}
            category={category}
            imageUrl={
              inspirations!.find((i) => i.category === category)!.thumbnail
            }
          />
        ))}
      </HStack>
    </HStack>
  );
};
